const SCHLUESSEL = "am-status-token";

/** Token aus dem Link (hinter „#“). Ohne Fragment (z. B. Nachrichten-App hat es abgeschnitten) der zuletzt geöffnete. */
export function tokenErmitteln(): string | null {
  const ausLink = window.location.hash.replace(/^#/, "").trim();
  try {
    if (ausLink) {
      localStorage.setItem(SCHLUESSEL, ausLink);
      return ausLink;
    }
    return localStorage.getItem(SCHLUESSEL);
  } catch {
    return ausLink || null;
  }
}

export function tokenVergessen(): void {
  try {
    localStorage.removeItem(SCHLUESSEL);
  } catch {
    // ohne Speicher nichts zu tun
  }
}

/**
 * Eigenes Manifest für die Statusseite: index.html verweist auf das Portal-Manifest (start_url „/portal“),
 * das Home-Bildschirm-Icon würde sonst das Installateur-Login öffnen. Die Start-Adresse enthält den Token,
 * damit das Icon immer direkt den Status des Kunden zeigt. Gibt die Aufräumfunktion zurück.
 */
export function statusManifestSetzen(token: string, marke?: { name: string; icon: string } | null): () => void {
  const verweis = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
  const titel = document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]');
  if (!verweis) return () => {};

  const herkunft = window.location.origin;
  const manifest = {
    id: `${herkunft}/status`,
    name: marke ? `${marke.name} – Mein Status` : "Mein Solar-Status",
    short_name: "Solar-Status",
    lang: "de",
    start_url: `${herkunft}/status#${token}`,
    scope: `${herkunft}/status`,
    display: "standalone",
    background_color: "#fafafa",
    theme_color: "#ffffff",
    icons: marke
      ? [{ src: marke.icon, sizes: "512x512", type: "image/png", purpose: "any" }]
      : [
      { src: `${herkunft}/icons/icon-192.png`, sizes: "192x192", type: "image/png", purpose: "any" },
      { src: `${herkunft}/icons/icon-512.png`, sizes: "512x512", type: "image/png", purpose: "any" },
      { src: `${herkunft}/icons/icon-maskable-512.png`, sizes: "512x512", type: "image/png", purpose: "maskable" },
        ],
  };
  const url = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: "application/manifest+json" }));
  const altesManifest = verweis.href;
  const alterTitel = titel?.content;
  verweis.href = url;
  if (titel) titel.content = "Solar-Status";

  return () => {
    verweis.href = altesManifest;
    if (titel && alterTitel !== undefined) titel.content = alterTitel;
    URL.revokeObjectURL(url);
  };
}
